import { render, staticRenderFns } from "./actionOrder.vue?vue&type=template&id=2f4ad637&"
import script from "./actionOrder.vue?vue&type=script&lang=js&"
export * from "./actionOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports